import {
  faChartMixed,
  faChartPie,
  faChartLine,
  faChartLineDown,
  faChartBar,
  faChartColumn,
  faChartArea,
  faCalendarAlt,
  faMap,
  faRectangleList,
  faSitemap,
  faTable,
  faChartScatter,
  faTrafficLightStop,
  faSpiderWeb,
  faTachometer,
  faChartNetwork,
  faAnalytics,
  faSignalAlt,
  faAlignLeft,
} from "@fortawesome/pro-light-svg-icons";
import { environment } from "@environments/environment";

const enableListChart = environment.disableUI.enableListChart || false;

export const CHARTS: any[] = [
  {
    name: "Existing",
    type: { type: "chart", details: "existing" },
    icon: faChartMixed,
    class: "",
    enabled: true,
  },
  {
    name: "Table",
    type: { type: "chart", details: "Table" },
    icon: faTable,
    class: "",
    enabled: true,
  },
  {
    name: "List",
    type: { type: "chart", details: "List" },
    icon: faRectangleList,
    class: "",
    enabled: enableListChart,
  },

  {
    name: "Line",
    type: { type: "chart", details: "Line" },
    icon: faChartLine,
    class: "",
    enabled: true,
  },
  {
    name: "Bar",
    type: { type: "chart", details: "Bar" },
    icon: faChartBar,
    class: "",
    enabled: true,
  },
  {
    name: "Column",
    type: { type: "chart", details: "Column" },
    icon: faChartColumn,
    class: "",
    enabled: true,
  },
  {
    name: "Area",
    type: { type: "chart", details: "Area" },
    icon: faChartArea,
    class: "",
    enabled: true,
  },
  {
    name: "Pie Chart",
    type: { type: "chart", details: "Pie" },
    icon: faChartPie,
    class: "",
    enabled: true,
  },
  {
    name: "Spline",
    type: { type: "chart", details: "Spline" },
    icon: faChartLineDown,
    class: "",
    enabled: true,
  },
  {
    name: "Scatter Plot",
    type: { type: "chart", details: "Scatter" },
    icon: faChartScatter,
    class: "",
    enabled: true,
  },
  {
    name: "Calendar",
    type: { type: "chart", details: "Calendar" },
    icon: faCalendarAlt,
    enabled: false,
  },

  {
    name: "Heat Map",
    type: { type: "chart", details: "Heat" },
    icon: faChartScatter,
    enabled: false,
  },
  {
    name: "Maps",
    type: { type: "chart", details: "Maps" },
    icon: faMap,
    enabled: false,
  },
  {
    name: "Arc",
    type: { type: "chart", details: "Arc" },
    icon: faTachometer,
    enabled: false,
  },
  {
    name: "Spiderweb",
    type: { type: "chart", details: "Spiderweb" },
    icon: faSpiderWeb,
    enabled: false,
  },
  {
    name: "Sparkline",
    type: { type: "chart", details: "Table" },
    icon: faChartLine,
    enabled: false,
  },
  {
    name: "Bubble",
    type: { type: "chart", details: "Bubble" },
    icon: faChartNetwork,
    enabled: false,
  },
  {
    name: "Pareto",
    type: { type: "chart", details: "Pareto" },
    icon: faAnalytics,
    enabled: false,
  },
  {
    name: "Organization Chart",
    type: { type: "chart", details: "Organization" },
    icon: faSitemap,
    enabled: false,
  },
  {
    name: "Stoplight",
    type: { type: "chart", details: "Stoplight" },
    icon: faTrafficLightStop,
    enabled: false,
  },
];
